export { default as Input } from './input';

//# sourceMappingURL=index.js.map